module.exports = "/_next/static/images/Trend04Visual-818e5010936513e48fa2fbb95ccfda00.webp";